"use client";

import Image from "next/image";
import {
  Marquee,
  MarqueeContent,
  MarqueeItem,
} from "@/components/kibo-ui/marquee";
import AnimateOnScroll from "./AnimateOnScroll";

const highlights = [
  {
    title: "Your Unique Approach",
    img: "/images/marquee/ribon-1.png",
  },
  {
    title: "Committed To You",
    img: "/images/marquee/ribon-2.png",
  },
  {
    title: "Your Personal Growth",
    img: "/images/marquee/ribon-3.png",
  },
  {
    title: "Dedicated To Progress",
    img: "/images/marquee/ribon-4.png",
  },
  {
    title: "Support That Works",
    img: "/images/marquee/ribon-5.png",
  },
  {
    title: "Focused On You",
    img: "/images/marquee/ribon-6.png",
  },
  {
    title: "Real Lasting Change",
    img: "/images/marquee/ribon-7.png",
  },
  {
    title: "Simple Clear Care",
    img: "/images/marquee/ribon-8.png",
  },
];

interface HighlightsMarqueeProps {
  subtitle?: string;
  title?: React.ReactNode;
  description?: string;
}

const HighlightsMarquee = ({
  subtitle = "What Sets Us Apart",
  title = (
    <>
      Why Clients Choose
      <br />
      Ours
    </>
  ),
  description = "We combine professional training with a genuine commitment to your progress. Every session is purposeful, confidential, and built around your unique needs.",
}: HighlightsMarqueeProps) => {
  return (
    <section className="overflow-hidden bg-[#F7FAFF]">
      {/* Header */}
      <div className="container-x pt-10 pb-8 xl:pt-12 xl:pb-10 2xl:pt-14 2xl:pb-12 3xl:pt-14 4xl:pt-16 5xl:pt-20">
        <AnimateOnScroll className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-col gap-3">
            <span className="font-crimsonText text-[20px] font-bold text-v3-highlight sm:text-[24px]">
              {subtitle}
            </span>
            <h2 className="heading text-v3-secondary">{title}</h2>
          </div>
          <p className="font-onest text-[16px] font-normal leading-[1.5] text-v3-body lg:max-w-[460px] lg:text-[18px]">
            {description}
          </p>
        </AnimateOnScroll>
      </div>

      {/* Full-width marquee strip */}
      <Marquee>
        <MarqueeContent className="bg-v3-secondary py-5" speed={35}>
          {highlights.map((item, index) => (
            <MarqueeItem
              key={index}
              className="flex items-center gap-5 px-6"
            >
              <p className="max-w-[220px] font-onest text-[15px] font-medium leading-[1.25] text-white sm:text-[16px]">
                {item.title}
              </p>
              <span
                className="ml-4 select-none font-crimsonText text-[18px] text-white/20"
                aria-hidden
              >
                ◆
              </span>
            </MarqueeItem>
          ))}
        </MarqueeContent>
      </Marquee>

      {/* Bottom spacing to mirror top */}
      <div className="h-10 xl:h-12 2xl:h-14 3xl:h-14 4xl:h-16 5xl:h-20" />
    </section>
  );
};

export default HighlightsMarquee;
